// =============================================================================
// PickerTakeOnGate.jsx
// =============================================================================
// The picker "Take-On" gate — the SO-scoped equivalent of TakeOnLock. When a
// picker opens an UNASSIGNED Sales Order from the Pickers List (via the Ref link),
// this walks them through claiming it before they can enter costs / order numbers
// or send it (mirrors the Responders take-on flow, but per SO not per request).
//
// The list's "Assign to Me" button claims + opens in one step, so it arrives past
// this gate; the Ref link opens unclaimed and lands here.
//
// Props
// ─────
//   req       — request object (read for refNo, fallback heading)
//   soNumber  — the Sales Order the picker opened (heading + context)
//   takingOn  — true while the claim is in flight (disables the button)
//   onAssign  — handler invoked when the button is clicked
// =============================================================================
import { GLYPH } from "../../utils/glyphs";
import { formatRef } from "../../utils/helpers";

export function PickerTakeOnGate({ req, soNumber, takingOn, onAssign }) {
  return (
    <div>
      <h1 style={{ margin: "0 0 16px", fontSize: 22, color: "#1A2E2B" }}>
        {`Order ${soNumber || formatRef(req?.refNo)}`}
      </h1>
      <div
        style={{
          background: "#FFF8E1",
          border: "2px solid #FFB300",
          borderRadius: 12,
          padding: "28px 32px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 22, marginBottom: 8 }}>{GLYPH.lock}</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#E65100", marginBottom: 6 }}>
          This order hasn't been assigned to anyone yet
        </div>
        <div style={{ fontSize: 13, color: "#795548", marginBottom: 16 }}>
          You must assign this order to yourself before you can enter costs, record order numbers,
          or send it.
        </div>
        <button
          type="button"
          onClick={onAssign}
          disabled={takingOn}
          style={{
            background: "#2E7D32",
            color: "white",
            border: "none",
            borderRadius: 8,
            padding: "12px 32px",
            fontSize: 15,
            fontWeight: 700,
            cursor: takingOn ? "default" : "pointer",
            fontFamily: "inherit",
            opacity: takingOn ? 0.6 : 1,
          }}
        >
          {takingOn ? "Assigning..." : "Assign this order to me"}
        </button>
      </div>
    </div>
  );
}
